
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function dialogButtonMobileRT () {
    return _createElement('div', { 'className': 'cm_search-box-root__dialog_open-button' }, [this.searchBoxDialogButton(function () {
            return _createElement('div', { 'className': 'cm_desktop-hide search-toggle-icon cm_searchBoxDialogButton' }, _createElement('svg', {
                'aria-hidden': 'true',
                'className': 'kadence-svg-icon kadence-search-svg icon icon-search',
                'fill': 'currentColor',
                'version': '1.1',
                'xmlns': 'http://www.w3.org/2000/svg',
                'width': '26',
                'height': '28',
                'viewBox': '0 0 26 28'
            }, _createElement('title', {}, 'Search'), _createElement('path', { 'd': 'M18 13c0-3.859-3.141-7-7-7s-7 3.141-7 7 3.141 7 7 7 7-3.141 7-7zM26 26c0 1.094-0.906 2-2 2-0.531 0-1.047-0.219-1.406-0.594l-5.359-5.344c-1.828 1.266-4.016 1.937-6.234 1.937-6.078 0-11-4.922-11-11s4.922-11 11-11 11 4.922 11 11c0 2.219-0.672 4.406-1.937 6.234l5.359 5.359c0.359 0.359 0.578 0.875 0.578 1.406z' })));
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:searchBoxDialogButton"]